/* unplugin-vue-components disabled */import script from "./EmployeeDetailsExpanded.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployeeDetailsExpanded.vue?vue&type=script&setup=true&lang=js"

import "./EmployeeDetailsExpanded.vue?vue&type=style&index=0&id=11cbbf05&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11cbbf05"]])

export default __exports__